module.exports = ".task {\n  color: #222;\n  text-transform: capitalize;\n  line-height: 60px;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  border: solid 1px #ddd; }\n  .task a {\n    color: #222; }\n  .task .title {\n    font-weight: 600; }\n  .task .duedate {\n    font-size: .8em; }\n  .task:hover {\n    background-color: #f8f8f8; }\n  .btn-special.btn-pending {\n  background-color: #444; }\n  .btn-special.btn-released {\n  background-color: green; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/stage/containers/tasks-container/tasks-container.component.scss
// module id = ./src/app/stage/containers/tasks-container/tasks-container.component.scss
// module chunks = main